module.exports = __webpack_public_path__ + "static/media/orderTypesBackground.c60a70ef.png";